import React from 'react';
import DOMPurify from 'dompurify';
import { Card, Container, Dropdown, Form, DropdownButton, Button,  Accordion, Row, Col } from 'react-bootstrap';
import { FaBook , FaBlog, FaSearch, FaEdit, FaCheck, FaTags, FaExpandArrowsAlt} from 'react-icons/fa';

import classes from './NewHadith.css';

const createMarkup = (html) => {
    return  {
      __html: DOMPurify.sanitize(html)
    }
  }

  
const blog = ( props ) => {
    let borderColor = props.complete ? "black" : "lightgray";
    var data = props.data;
    let statusIcon = props.complete ? <FaCheck /> : <FaEdit />;

    return (

      <div className={classes.Blog} style={{border:'1px solid '+borderColor}}>
        <input type="text" value="New Hadith"></input>
      </div>



    );
};

export default blog;


// WEBPACK FOOTER //
// ./src/components/NewHadith/NewHadith.js